import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Progress } from 'semantic-ui-react';
import _ from 'lodash';

// import { populateFormInfo, populateSignupData } from '../../Actions';
import {
  getInitialData,
  nextQuestion,
  backQuestion,
  addValueToCurrentQuestion,
} from '../../Actions/actions_register';
import Question from './Onboarding/Question';
import { getRegisterLoading } from '../../reducers/session/selectors';
import { hasAccessOnNewPlatform } from '../../Services/SupabaseService';
import Loading from '../Loading';

class RegisterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasAccessOnNewPlatform: false,
      isLoading: false,
      isInitialized: false,
    };
  }
  componentDidMount() {
    const { getInitialData, history, user } = this.props;

    if (!_.isEmpty(user) && user.last_name !== '') {
      history.push('/dashboard');
    } else {
      getInitialData();
    }
  }

  componentDidUpdate() {
    const { user } = this.props;
    const { isLoading, isInitialized } = this.state;
    if (user && user.email && !isLoading && !isInitialized) {
      this.setState({ isInitialized: true, isLoading: true });
      hasAccessOnNewPlatform(user.email).then((hasAccess) => {
        this.setState({
          hasAccessOnNewPlatform: hasAccess,
          isLoading: false,
          isInitialized: true,
        });
      });
    }
  }

  calculateTotalQuestionQuantity(modules, moduleIndexStart, moduleIndexEnd) {
    let total = 0;
    for (let i = moduleIndexStart; i < moduleIndexEnd; i++) {
      const currentModule = _.get(modules, `[${i}]`, {});
      total = total + _.get(currentModule, 'questions.length', 1);
    }
    return total;
  }

  render() {
    const {
      register,
      posting,
      nextQuestion,
      backQuestion,
      addValueToCurrentQuestion,
    } = this.props;

    const {
      isLastQuestion,
      moduleIndex,
      questionIndex,
      modules,
      values,
    } = register;

    const { hasAccessOnNewPlatform, isLoading } = this.state;

    const currentModule = _.get(modules, `[${moduleIndex}]`, {});
    const currentQuestion = _.cloneDeep(
      _.get(currentModule, `questions[${questionIndex}]`, { question: '' })
    );
    const questionValue = _.get(values, `[${currentQuestion.identifier}]`, '');

    const totalQuestions = this.calculateTotalQuestionQuantity(
      modules,
      0,
      modules.length
    );
    const askedQuestions =
      this.calculateTotalQuestionQuantity(modules, 0, moduleIndex) +
      questionIndex;
    const totalProgress = (askedQuestions * 100) / totalQuestions;

    // Replace plaholders if any
    const placeholder = currentQuestion.question.match('{{(.*)}}');
    if (placeholder) {
      currentQuestion.question = currentQuestion.question.replace(
        placeholder[0],
        _.get(values, placeholder[1].trim(), '')
      );
    }

    const onKeyDown = (e) => {
      const targetName = _.get(e, 'target.nodeName');
      const ignoreEnter = e.target.parentElement.getAttribute(
        'data-ignore-enter'
      );
      if (ignoreEnter) return;
      if (
        (e.keyCode === 13 && targetName !== 'TEXTAREA') ||
        (targetName !== 'TEXTAREA' &&
          targetName !== 'INPUT' &&
          e.keyCode === 39)
      ) {
        nextQuestion();
      } else if (
        e.keyCode === 37 &&
        targetName !== 'INPUT' &&
        targetName !== 'TEXTAREA'
      ) {
        backQuestion();
      }
    };

    let nextBtnLabel = '';
    if (isLastQuestion) {
      nextBtnLabel = 'Finish';
    } else if (currentQuestion.optional && _.isEmpty(questionValue)) {
      nextBtnLabel = 'Skip';
    } else {
      nextBtnLabel = 'Next';
    }

    return (
      <div
        className="register-page"
        tabIndex="0"
        onKeyDown={onKeyDown}
        role="button"
      >
        <div className="page-content">
          {posting && <Loading />}
          {!posting && (
            <React.Fragment>
              <div className="question-container">
                <div className="row_small_space ">
                  <div>
                    <div className="section-title">{currentModule.name}</div>
                  </div>
                </div>
                <div className="row_small_space ">
                  <div className="progress_bar">
                    <Progress
                      percent={totalProgress}
                      size="tiny"
                      color="blue"
                    />
                  </div>
                </div>

                <Question
                  question={currentQuestion}
                  onChange={addValueToCurrentQuestion}
                  value={questionValue}
                  nextQuestion={nextQuestion}
                  user={this.props.user}
                  hasAccessOnNewPlatform={hasAccessOnNewPlatform}
                  loading={isLoading}
                />
              </div>
              <div className="button_container">
                <Button className="prev_button" onClick={backQuestion}>
                  <Icon name="angle left" />
                </Button>

                <Button
                  className="next_button"
                  color="twitter"
                  animated
                  onClick={nextQuestion}
                >
                  <Button.Content visible>{nextBtnLabel}</Button.Content>
                  <Button.Content hidden>
                    <Icon name="angle right" />
                  </Button.Content>
                </Button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  register: state.register,
  posting: getRegisterLoading(state),
});

export default connect(mapStateToProps, {
  getInitialData,
  nextQuestion,
  backQuestion,
  addValueToCurrentQuestion,
})(RegisterPage);
